import { Component, OnInit } from '@angular/core';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { ConfiguracionCompensacion, ConfiguracionCompensacionPK } from 'src/app/models/configuracionCompensacion.model';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModalSolicitudAjusteCompensacion } from '../modal-solicitud-ajuste-compensacion/modal-solicitud-ajuste-compensacion.component';
import { SolicitudAjuste } from 'src/app/models/solicitudAjuste.model';
import { UploadService } from 'src/app/shared/upload.service';

@Component({
    selector: 'app-solicitud-ajuste-compensacion',
    templateUrl: './solicitud-ajuste-compensacion.component.html'
})
export class SolicitudAjusteCompensacionComponent implements OnInit {
    fechaActual: Date;
    tipoDocumento: string;
    numeroDocumento: string;

    estadosInscripcion: DetalleDominio[];

    plan: PlanCompensatorioModel;
    inscripcion: ConfiguracionCompensacion;
    solicitud: SolicitudAjuste;

    turnoSeleccionado: any;
    codigoTurnoAnterior: number;
    edicionInscripcion: boolean;
    estadoInscripcion: string;
    bloquearBotonSolicitarAjuste: boolean;
    mostrarRedireccionInscripcion: boolean;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService,
        private modalService: NgbModal,
        private uploadService: UploadService) {
    }

    ngOnInit(): void {
        this.fechaActual = new Date();
        this.bloquearBotonSolicitarAjuste = true;
        this.mostrarRedireccionInscripcion = false;
        this.tipoDocumento = sessionStorage.getItem('tipoDocumento');
        this.numeroDocumento = sessionStorage.getItem('numDocumento');

        this.inscripcion = new ConfiguracionCompensacion();
        this.inscripcion.configuracionCompensacionPK = new ConfiguracionCompensacionPK();
        this.inscripcion.configuracionCompensacionPK.tipoIdFuncionario = this.tipoDocumento;
        this.inscripcion.configuracionCompensacionPK.numeroIdFuncionario = this.numeroDocumento;
        this.inscripcion.estado = DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_PENDIENTE;
        this.inscripcion.horasAjuste = 0;
        this.inscripcion.porcentajeCompensacion = 0;
        this.edicionInscripcion = false;
        this.codigoTurnoAnterior = 0;

        this.obtenerDominio('EstadoInscripcionPlanCompensacion', 'estadosInscripcion');
        this.consultarPlanCompensacionActual();
    }

    /**
     * Método que permite habilitar o deshabilitar el botón para realizar solicitud de ajuste
     * @function habilitarBotonSolitarAjuste
     * @author dfranco@asesoftware.com
     */
    public habilitarBotonSolitarAjuste() {
        this.bloquearBotonSolicitarAjuste =
            this.inscripcion.porcentajeCompensacion === 100 ||
            ((this.utilService.setearFinFecha(new Date(this.plan.fechaFinal))).getTime() > 
            this.utilService.setearFinFecha(this.fechaActual).getTime()) ||
            ((this.utilService.setearFinFecha(new Date(this.plan.listaTurnos[0].fechaInicial))).getTime()
             < this.utilService.setearFinFecha(this.fechaActual).getTime()) ||
            (this.inscripcion !== undefined
                && this.inscripcion.estado !== DominiosService.ESTADO_INSCRIPCION_PLAN_COMPENSACION_APROBADO) ||
            !!this.solicitud;
    }

    /**
     * Método que permite actualizar el DTO con la opción de turno seleccionada por el usuario
     * @author dfranco@asesoftware.com
     * @function asosciarTurnoAInscripcion
     */
    public asosciarTurnoAInscripcion() {
        if (this.turnoSeleccionado !== undefined) {
            this.inscripcion.configuracionCompensacionPK.turnoIdTurno = this.turnoSeleccionado.idTurno;
        }
    }

    /**
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     * @function obtenerDominio
     * @author dfranco@asesoftware.com
     * @param filtro Dominio a consultar
     * @param lista Variable a la que se va a asignar el resultado
     */
    obtenerDominio(filtro, lista) {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            data => {
                this[lista] = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    /**
     * Método que permite consultar el plan de compensación activo o actual
     * @function consultarPlanCompensacionActual
     * @author dfranco@asesoftware.com
     */
    public consultarPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=estado', DominiosService.ESTADO_PLAN_COMPENSACION_ACTIVO]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data.length > 0) {
                    this.plan = data[0];
                    this.consultarTurnosPlanCompensacionActual();
                } else {
                    this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTE_PLAN_COMPENSACION, '');
                }
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar los turnos parametrizados en el plan de compensación actual
     * @author dfranco@asesoftware.com
     * @function consultarTurnosPlanCompensacionActual
     */
    public consultarTurnosPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarTurnosCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy',
            this.urlService.encodeURI('idPlanCompensacion=' + this.plan.idPlanCompensacion.toString() + '&estado=ACT')]);
        queryParams.push(['orderBy', 'fechaInicial']);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.plan.listaTurnos = data;
                this.consultarInscripcionFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar inscripción del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar la inscripción del formulario al plan de compensación actual
     * @function consultarInscripcionFuncionario
     * @author dfranco@asesoftware.com
     */
    public consultarInscripcionFuncionario() {
        this.spinner.show();
        const serviceProvider = 'validarInscripcionPlanActual';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numeroDocumento', this.numeroDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data) {
                    this.inscripcion = data;
                    this.codigoTurnoAnterior = this.inscripcion.configuracionCompensacionPK.turnoIdTurno;
                    this.edicionInscripcion = true;
                    const turnoEncontrado = this.plan.listaTurnos.filter(
                        turno => turno.idTurno === this.inscripcion.configuracionCompensacionPK.turnoIdTurno);
                    if (turnoEncontrado !== undefined && turnoEncontrado.length > 0) {
                        this.turnoSeleccionado = turnoEncontrado[0];
                    }
                } else {
                    this.alertService.generateAlertError('No se ha inscrito a un plan de compensación', '');
                    this.mostrarRedireccionInscripcion = true;
                }
                if (this.estadosInscripcion !== undefined) {
                    const estadosFiltrados = this.estadosInscripcion.filter(
                        estado => estado.detalleDominioPK.nombreDetalleDominio === this.inscripcion.estado);
                    if (estadosFiltrados.length > 0) {
                        this.estadoInscripcion = estadosFiltrados[0].valor;
                    }
                }
                this.consultarAjusteFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar inscripción del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar la solicitud más reciente al plan de compensación actual
     * @function consultarAjusteFuncionario
     * @author dfranco@asesoftware.com
     */
    public consultarAjusteFuncionario() {
        this.spinner.show();
        const serviceProvider = 'validarSolicitudAjustePlanActual';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numeroDocumento', this.numeroDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.solicitud = data;
                this.habilitarBotonSolitarAjuste();
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar solicitud de ajuste del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite abrir el modal de solicitar ajuste y capturar la respuesta que se obtenga al cerrar el mismo
     * @function abrirModaAjuste
     * @author dfranco@asesoftware.com
     */
    public abrirModaAjuste() {
        const modalRef = this.modalService.open(
            ModalSolicitudAjusteCompensacion, { centered: true, size: 'lg' });
        modalRef.result.then((result) => {
            if (result) {
                this.crearSolicitudAjuste(result.observaciones, result.soportes);
            }
        }, (reason) => {
            if (reason === ModalDismissReasons.ESC ||
                reason === ModalDismissReasons.BACKDROP_CLICK) { }
        });
    }

    public crearSolicitudAjuste(observaciones: string, soportes: any[]) {
        this.spinner.show();
        const solicitud: SolicitudAjuste = new SolicitudAjuste();
        solicitud.descripcion = observaciones;
        solicitud.estado = DominiosService.ESTADO_AJUSTE_PLAN_COMPENSACION_PENDIENTE;
        solicitud.tipoIdFuncionario = this.tipoDocumento;
        solicitud.numeroIdFuncionario = this.numeroDocumento;
        solicitud.idTurno = this.turnoSeleccionado.idTurno;

        const formData = new FormData();
        formData.append('tipoDocumento', this.tipoDocumento);
        formData.append('numeroDocumento', this.numeroDocumento);
        formData.append('idTurno', this.turnoSeleccionado.idTurno);
        formData.append('descripcion', observaciones);
        for (const soporte of soportes) {
            formData.append('file', soporte, soporte.name);
        }
        this.uploadService.cargarArchivoFotoARL('/servicios/solicitudajuste/crearSolicitudAjuste',formData).subscribe(
            data => {
                this.spinner.hide();
                this.alertService.generateAlertSuccess(
                    ConstantesService.MENSAJE_EXITO_SOLICITUD_AJUSTE, '');
                this.consultarInscripcionFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException(ConstantesService.MENSAJE_ERROR_SOLICITUD_AJUSTE);
                }
            }
        );
    }

    inscribirPlanCompensacion() {
        this.router.navigate(['/main/plan-compensatorio/inscripcion-compensacion']);
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }
}